import { render, staticRenderFns } from "./products-tab.vue?vue&type=template&id=2f43cfbb&"
import script from "./products-tab.vue?vue&type=script&lang=js&"
export * from "./products-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports